import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import i18n from "i18next";
import {
  getAggregatedData,
  getAggregatedDataWrapper,
  onFilterModelChange,
  renderGrid,
  aggregatedAdministrativeTableColumns,
} from "./AgroAnalyticsUtils";

import { capitalizeFirstLetterFormatter, fixedFormatter, null2DashFormatter } from "../util/tableUtils";
const aggregatedCoverageTableColumns = () => [
  {
    field: "Anno",
    headerName: i18n.t("agriculture.year"),
    width: 60,
  },

  {
    field: "Compagnia",
    headerName: i18n.t("company"),
    width: 60,
  },

  {
    field: "CodiceGaranzia",
    headerName: i18n.t("agriculture.perilCode"),
    width: 50,
    type: "str",
    ...fixedFormatter,
  },

  {
    field: "DescrizioneGaranzia",
    headerName: i18n.t("agriculture.perilName"),
    width: 250,
    type: "str",
    ...capitalizeFirstLetterFormatter,
  },

  {
    field: "RischioClimatico",
    headerName: "Rischio Climatico",
    width: 100,
    type: "str",
    ...null2DashFormatter,
  },
  /*
    {
      field: "hazardlist",
      headerName: "hazardlist", // translator will be used here
      width: 100,
      type: "str",
    },
    */
  ...aggregatedAdministrativeTableColumns(),
];

export const AgroCoverageGrid = ({ filterModel, wantedReferenceDateProp }) => {
  const { t } = useTranslation();

  const [aggregatedCoverageTableState, setAggregatedCoverageTableState] = useState({
    isLoading: false,
    total: 0,
  });

  const aggregatedCoverageCancelTokenRef = useRef(null);

  const [aggregatedCoverageTableData, setAggregatedCoverageTableData] = useState([]);

  useEffect(() => {
    const getAggregatedCoverageData = async () => {
      return await getAggregatedData(
        setAggregatedCoverageTableState,
        setAggregatedCoverageTableData,
        { aggr: "CodiceGaranzia" },
        filterModel,
        wantedReferenceDateProp,
        aggregatedCoverageCancelTokenRef,
      );
    };
    const getAggregatedCoverageDataWrapper = async () => {
      getAggregatedDataWrapper(aggregatedCoverageCancelTokenRef, getAggregatedCoverageData);
    };

    onFilterModelChange(filterModel, getAggregatedCoverageDataWrapper);
  }, [filterModel, wantedReferenceDateProp]);

  return renderGrid(
    aggregatedCoverageTableColumns(),
    aggregatedCoverageTableData,
    aggregatedCoverageTableState,
    t,
    "Garanzia",
  );
};
